// extracted by css-extract-rspack-plugin
export default {"container":"container-sk9NQr"};